import { render, staticRenderFns } from "./LazyCompareSimilarCarousel.vue?vue&type=template&id=c8021de8"
import script from "./LazyCompareSimilarCarousel.vue?vue&type=script&setup=true&lang=ts"
export * from "./LazyCompareSimilarCarousel.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports